import { isCep } from 'validator-brazil';

import { IViaCepAddress } from '~/models/Common';
import ViaCep from '~/services/ViaCepService';
import removeMark from '~/utils/yupHelpers';

export default async function getCEP(
  cepWithMark: string,
  lastCepSearched?: string,
): Promise<IViaCepAddress | never> {
  if (isCep(cepWithMark) && lastCepSearched !== cepWithMark) {
    const onlyNumbers = removeMark(cepWithMark);
    const {
      data: {
        bairro: address_neighborhood,
        localidade: address_city,
        logradouro: address_street,
        uf: address_state,
        complemento: address_complement,
        erro,
      },
    } = await ViaCep.callData(onlyNumbers);

    if (erro) {
      throw new Error('CEP não encontrado');
    }

    return {
      address_city,
      address_complement,
      address_neighborhood,
      address_street,
      address_state,
    };
  }

  throw new Error('CEP inválido');
}
